module.exports = ".width-10{\n    width: 10%\n}\n.width-20{\n    width: 20%\n}\n.width-30{\n    width: 30%\n}"